export const TOGGLE_PRODUCTS_TO_COMPARE = 'TOGGLE_PRODUCTS_TO_COMPARE';
export const RESET_PRODUCTS_COMPARE = 'RESET_PRODUCTS_COMPARE';
export const SET_ZONE_PARAM = 'SET_ZONE_PARAM';
export const PRODUCTS_BY_ID_SUCCESS_FOR_COMPARE = 'PRODUCTS_BY_ID_SUCCESS_FOR_COMPARE';
